import React, { useCallback, useState } from 'react'
import { isEmptyString } from '../../../../utils/string-utils'
import { IconButton, Tooltip } from '@mui/material'
import DatasetLinkedIcon from '@mui/icons-material/DatasetLinked'
import RiskLoaderModal from './risk-loader-modal'

export interface RiskLoaderModalTriggerProps {
  strategyId: string
  strategyName: string
  isApiConnected: boolean
  riskLoaderDataUrl: string | null
  riskLoaderPostUrl: string | null
}

const RiskLoaderModalTrigger: React.FC<RiskLoaderModalTriggerProps> = (props) => {
  const { strategyId, strategyName, isApiConnected, riskLoaderDataUrl, riskLoaderPostUrl } = props
  const isDisabled = !isApiConnected || isEmptyString(riskLoaderDataUrl)

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  const openModal = useCallback(() => {
    setIsModalOpen(true)
  }, [])

  const closeModal = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  return (
    <>
      <RiskLoaderModal
        open={isModalOpen}
        onClose={closeModal}
        strategyId={strategyId}
        title={`${strategyName} Risk Loader`}
        dataUrl={riskLoaderDataUrl}
        postUrl={riskLoaderPostUrl}
      />

      <Tooltip title='View risk loader'>
        <span>
          <IconButton size='small' disabled={isDisabled} onClick={openModal}>
            <DatasetLinkedIcon/>
          </IconButton>
        </span>
      </Tooltip>
    </>
  )
}

export default React.memo(RiskLoaderModalTrigger)
